import React from 'react';
import { Helmet } from 'react-helmet-async';
import { m } from 'framer-motion';
import Footer from '../Footer/Footer';

import './Adrian.scss';

import breaker from '../../assets/img/adrian/holder.jpg';
import { routes } from '../../routing/routes';

const heroimg = {
  background: 'url(' + breaker + ') no-repeat center center',
  backgroundSize: 'cover',
};

export default function Adrian() {
  return (
    <m.main
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 0.5 }}
      className="help"
    >
      <Helmet>
        <title>Second Collection Mint - DuskBreakers</title>
        <meta
          name="description"
          content="New NFT Collection from DuskBreakers - The Gribbles - a play-to-evolve egg to incubation to hatch experience"
        />
      </Helmet>
      <section
        className="
        d-flex
        align-items-center
        justify-content-center
        has-bg
      "
      >
        <div className="container">
          <div className="row justify-content-center mb-5">
            <div className="col-md-8 eggsperience-title text-center">
              <h1>The Gribble Eggsperience</h1>
            </div>
          </div>
        </div>

        <div className="is-bg fade-hero" style={heroimg} />
      </section>

      <section className="mt-n6 mt-lg-n7">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-md-8">
              <h2 className="text-center">Mint - Evolve - Explore - Play</h2>
              <p className="text-center">
                Enter the Gribble Eggsperience and take control of the evolution of your precious
                gribble egg by completing missions - including playing our newest game Twilight
                Shift - to collect OmniGrow, which when applied will level up your egg into the
                strongest gribble it can be.
              </p>
              <p className="text-center">
                <a className="btn btn-primary btn-md w-50" href={routes.mint()}>
                  ENTER
                </a>
              </p>
              <h2 className="mt-5">Welcome to the DuskBreakers Gribble Egg Mint Page</h2>
              <p className="mb-4 mt-0">
                We’re getting close to the mint of the Second NFT Collection in the DuskBreakers
                franchise, Gribble Eggs! This page is where our Gribble Egg mint will take place, so
                make sure to bookmark this page for quick access! This page will change when we get
                closer to the mint date.
              </p>

              <h3>Mint Date</h3>
              <p>The Gribble Egg mint date is August 19, 2022.</p>
              <h3>Genesis Breaker Holders</h3>
              <p>
                Genesis Breaker NFT Holders will be able to claim one Gribble Egg NFT per
                DuskBreaker NFT owned. There is no purchase cost for each claim, only for the
                Ethereum network gas fee for the transaction. Genesis holders have 30 days to claim,
                which allows you to optimize for low gas when minting.
              </p>

              <h3>Allow List Winners</h3>
              <p>
                An Allow List winner will be able to mint one Second Collection NFT per Allow List
                win. Allow List winners come from official DuskBreakers contests (eg, Beast Battler,
                Mad Libs, Gribble Art, Classic Mode, etc) and giveaways from our co-marketing
                partners.
              </p>
              <p>
                If you have not yet won an Allow List claim, follow our Twitter account as we will
                retweet co-marketing partners that have active contests for the DuskBreakers Second
                Collection Allow List.
              </p>

              <h3>Allow List Mint Price</h3>
              <p>The price per Allow List mint is 0.03 ETH.</p>
              <h3>Play 2 Mint</h3>
              <p>
                There will not be a public sale of our Second Collection, but we will offer a Play 2
                Mint experience as we did for our Genesis collection in 2021. By playing Twilight
                Shift, players will be able to earn an Allow List mint opportunity. More details on
                this soon.
              </p>
              <h3>Play New Game and Content Experiences to Evolve Your Egg</h3>
              <p>
                The Second Collection mint will launch alongside the new DuskBreakers game, Twilight
                Shift. By playing Twilight Shift and interacting with other new content experiences,
                you will earn points to upgrade your Gribble Egg NFT and watch as it evolves over
                the course of several weeks. The more you play, the better the stats!
              </p>
              <p>
                In the Fall, your egg will hatch into a Gribble, which you will be able to use in a
                new action-packed, multiplayer game.
              </p>
              <h3>FAQ</h3>
              <p>
                For more questions related to our Second Collection, please see{' '}
                <strong>FUTURE COLLECTIONS</strong> in our <a href={routes.faq()}>FAQ</a> and come
                to our <a href="http://discord.gg/duskbreakers">Discord</a> to join the
                conversation!
              </p>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </m.main>
  );
}
